import React, { useRef, useEffect, useState, useContext } from "react";
import axios from 'axios';
import './Modal.css'; // Assuming you have some basic styles for the modal
import { ReactComponent as Close } from '../../svg/close.svg';
import { moneyMaker } from '../../utils';
import { ReactComponent as Taria_Gold } from '../../svg/Taria_Gold.svg';
import { ReactComponent as Taria_Silver } from '../../svg/Taria_Silver.svg';
import { ReactComponent as Taria_Bronze } from '../../svg/Taria_Bronze.svg';
import { Context } from '../../context';
import { ContextInventaire } from '../panels/Inventaire/ContextInventaire';
function ModalItemDescription({ isOpen, item, setOpen,token }) {
    const ip = process.env.REACT_APP_IP;
    const [money, setMoney] = useState({});
    const { idPerso } = useContext(Context);
    const fetchItems = useContext(ContextInventaire);
    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref, setOpen]);
    }

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);

    const handleSuppr = async () => {
        try {
            await axios.delete(`${ip}/item/${item.idItem}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: { idPerso } // Move data inside the config object, alongside headers
            });
            fetchItems(); // Refresh items
            setOpen(false); // Close the modal
        } catch (error) {
            console.error('Erreur:', error);
        }
    };

    useEffect(() => {
        if (item) {
            setMoney(moneyMaker(item.valeur));
        }
    }, [item]);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className='modal_flex' ref={wrapperRef}>
                <div className="close" onClick={() => setOpen(false)}><Close /></div>
                <div className='modal_title'>{item.item_nom}</div>
                <div className="modal_bloc"><strong>Description :</strong> {item.item_description}</div>
                <hr className="modal_separator" />
                <div className="modal_bloc"><strong>Effet :</strong> {item.effet}</div>
                <hr className="modal_separator" />
                <div className="modal_bloc flex space_around">
                    <div className="modal_moneys flex">
                        <span>{money.or}</span>
                        <Taria_Gold className="modal_money" />
                        <span>{money.argent}</span>
                        <Taria_Silver className="modal_money" />
                        <span>{money.bronze}</span>
                        <Taria_Bronze className="modal_money" />
                    </div>
                    <div className="modal_moneys">
                        <span><strong>Qté :</strong> {item.quantite}</span>
                    </div>
                </div>
                <hr className="modal_separator" />
                <div className="all_tags modal_bloc">
                    {item.tags.map((tag, index) => (
                        <div
                            key={index}
                            className={'tag'}
                        >
                            <span className="tag_text">{tag}</span>
                        </div>
                    ))}
                </div>

                <div className="modal_bloc flex space_around">
                    <button className="modal_suppr" onClick={handleSuppr}>Supprimer</button>
                </div>
            </div>
        </div>
    );
}

export default ModalItemDescription;
